<template>
  <div>
    <Head title="Create Inventory UIDs" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/sku-items">V2 UIDs</Link>
      <span class="text-orange-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-8 pr-6 w w-full lg:w-1/2">
            <p class="mb-2">Location</p>
            <multiselect
              id="location"
              v-model="form.location"
              placeholder="Search Locations"
              :options="locations"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.location"
              :style="form.errors.location ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
            />
            <div v-if="form.errors.location" class="form-error">{{ form.errors.location }}</div>
          </div>
          <div class="pb-8 pr-6 w w-full lg:w-1/2">
            <p class="mb-2">UID:</p>
            <text-input
              v-model="form.uid"
              :error="form.errors.uid"
              class="pb-8 pr-6"
              placeholder="UID"
            />
          </div>
          
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Generate UIDs</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    locations: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        uid: '',
        location: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/v2-uids', {
        onSuccess: () => {
          this.form.reset('uid')
        },
      })
      
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>
